import React from 'react';
import { DatePicker } from 'react-persian-datepicker';
import moment from 'moment-jalaali';

import 'react-persian-datepicker/lib/styles/basic.css';

const styles = {
  calendarContainer: 'calendarContainer',
  heading: 'heading',
  prev: 'prev',
  next: 'next',
  title: 'title',
  dayWrapper: 'dayWrapper',
  currentMonth: 'currentMonth',
  daysOfWeek: 'daysOfWeek',
  monthsList: 'monthsList',
  selected: 'selected',
  dayPickerContainer: 'dayPickerContainer'
};

export default class BDateInput extends React.Component {
  constructor(props) {
    super(props);
    
    //console.log('PropsValue',this.props.value);

    this.value = (props.value || moment()).toString();

    this.state = { value: moment()  };

    this.onDateChange = (value) => {
      //console.log('VALUE',value);
      
      this.value = value.toString();
      this.setState({ value });
      
      
    }

  }

  // fired after value props changed
  componentWillReceiveProps(nextProps) {
    
    console.log('nextProps',nextProps.value);
    try {
      this.value=nextProps.value;
      this.setState({ value: moment(nextProps.value)  });
    }
    catch(error) {
      console.error(error); 
    }
    
    
  }
  // fired after state changed
  shouldComponentUpdate(nextProps, nextState) {
    try {
      return ((this.state.value|| moment()).toString() !== (nextState.value|| moment()).toString() )||
      (this.value !== nextProps.value ) ;
    }
    catch(error) {
      console.error(error); 
    }
    
  }
  // fired after component render
  componentDidUpdate() {
    //console.log('UPDATE',this.props.value);
     this.props.onChange(this.state.value);
  }

  render() {
    return <DatePicker className="form-control" value={this.state.value}  onChange={this.onDateChange.bind(this)} calendarStyles={styles}  />;
  }
}